module.exports = __webpack_public_path__ + "static/media/1POLICY9.b00eb209.jpg";